// public/js/modules/features.js
// Per-environment feature flags, injected into window.APP_CONFIG.FEATURES by the
// server (see config.mjs and handlers/static.mjs).
//
// A flag answers "can this environment run the feature at all" — typically
// because it needs a table or bucket that only exists in some environments. It
// is NOT a permission: roles still decide who may use a feature. Both checks
// apply, and the flag is checked first because it is the cheaper failure.
//
// The default is OFF. An unknown flag, a missing FEATURES block, or an older
// cached index.html all resolve to false, so a half-deployed environment hides
// the feature rather than showing something that will fail on the first click.
// The server enforces the same flags on its routes — this only keeps the UI
// honest, it is not the security boundary.

const flags = () => (window.APP_CONFIG && window.APP_CONFIG.FEATURES) || {};

/** Is this feature switched on in the environment we are talking to? */
export function featureEnabled(name) {
  return flags()[name] === true;
}

/** All enabled flag names — handy for logging what an environment can do. */
export function enabledFeatures() {
  return Object.keys(flags()).filter(k => flags()[k] === true);
}
